import { createContext } from "react";


export let Token = createContext();